import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import _get from 'lodash/get';
import { useTranslation } from 'next-i18next';

const styles = () => ({
  root: {
    marginTop: 0,
    marginBottom: 0,
    paddingLeft: 30,
  },
});

const Index = ({
  classes,
  bundle_discount_type = 'dc_flat',
  bundle_criteria = [],
  bundle_max = 7,
  currency = 'MYR',
}) => {
  const { t } = useTranslation('common');
  const [translationKey, setTranslationKey] = useState('desc_dc_flat');

  useEffect(() => {
    let _translationKey = '';
    switch (bundle_discount_type) {
      case 'dc_flat':
        _translationKey = 'desc_dc_flat';
        break;
      case 'dc_perc':
        _translationKey = 'desc_dc_perc';
        break;
      case 'dc_fix_price':
        _translationKey = 'desc_dc_fix_price';
        break;
    }
    setTranslationKey(_translationKey);
  }, [bundle_discount_type]);

  return (
    <ul className={classes.root}>
      {bundle_criteria.length > 0
        ? bundle_criteria.map((data, i) => {
            const currentQuantity = _get(data, 'discount_min', 0);
            let hasNextQuantityRule = false;
            let hasReachedBundleMax = false;
            if (currentQuantity > 0) {
              const nextQuantity = currentQuantity + 1;
              hasNextQuantityRule = _get(bundle_criteria, `${i + 1}.discount_min`) === nextQuantity;
              if (bundle_max) {
                hasReachedBundleMax = currentQuantity === bundle_max;
              }
            }

            return (
              <li key={i}>
                {t(translationKey, {
                  discount_min: _get(data, 'discount_min', 0),
                  isShowOrMore: hasNextQuantityRule || hasReachedBundleMax ? '' : t('or_more'),
                  discount_value:
                    bundle_discount_type === 'dc_perc'
                      ? _get(data, 'discount_value', 0)
                      : _get(data, 'discount_value', 0).toFixed(2),
                  currency,
                })}
              </li>
            );
          })
        : null}
    </ul>
  );
};

Index.propTypes = {
  classes: PropTypes.object.isRequired,
  bundle_discount_type: PropTypes.string,
  bundle_criteria: PropTypes.array,
  bundle_max: PropTypes.number,
  currency: PropTypes.string,
};
export default withStyles(styles)(Index);
